import { render, staticRenderFns } from "./verificationIndex.vue?vue&type=template&id=4d5ff3b0&scoped=true"
import script from "./verificationIndex.vue?vue&type=script&lang=js"
export * from "./verificationIndex.vue?vue&type=script&lang=js"
import style0 from "./verificationIndex.vue?vue&type=style&index=0&id=4d5ff3b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ff3b0",
  null
  
)

export default component.exports